import { BilhetePassagem } from 'src/models/LinkPagamento';

import Drawer from '../../components/Drawer';

import { DetalhesViagem } from './DetalhesViagem';

export interface Props {
  bilhetes: BilhetePassagem[] | null;
  onClose: () => void;
}

const DrawerDetalhesViagem = ({ bilhetes, onClose }: Props) => {
  if (bilhetes === null) return null;

  return (
    <Drawer
      title="Informações da passagem"
      subtitle="Detalhes da viagem e da compra realizada."
      open={Boolean(bilhetes)}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: { xs: '92%', sm: '72%', md: '60%', lg: '52%', xl: '46%' },
          maxWidth: 720
        }
      }}
    >
      <DetalhesViagem bilhetes={bilhetes} />
    </Drawer>
  );
};

export default DrawerDetalhesViagem;
